// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import postFeed from "./postFeed";
import tableOfContents from "./tableOfContents";
import share from "./share";
import postTables from "./postTables";

postFeed();
tableOfContents();
share();
postTables();
